import type { CSSProperties } from "react";
import type { HighlightArea } from "./Search.types";

export const HighlightItem: React.FC<{
  index: number;
  area: HighlightArea;
}> = ({ index, area }) => {
  return <div data-index={index} style={getCssProperties(area)} />;
};

const getCssProperties = (area: HighlightArea): CSSProperties => {
  return {
    position: "absolute",
    backgroundColor: "rgba(215, 223, 37, 0.6)",
    left: area.left,
    top: area.top,
    height: area.height,
    width: area.width
  };
};
